import {h, Fragment} from "preact"
export function Select({ value, onChange, className, options }) {
    return (
        <div className="ns-sort-container">
              <div
                class="ns-sort-text-container"
            >
                <span class="ns-sort-text">
                    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1C13 0.723858 12.7761 0.5 12.5 0.5C12.2239 0.5 12 0.723858 12 1L13 1ZM12.1464 13.3536C12.3417 13.5488 12.6583 13.5488 12.8536 13.3536L16.0355 10.1716C16.2308 9.97631 16.2308 9.65973 16.0355 9.46447C15.8403 9.2692 15.5237 9.2692 15.3284 9.46447L12.5 12.2929L9.67157 9.46447C9.47631 9.2692 9.15973 9.2692 8.96447 9.46447C8.7692 9.65973 8.7692 9.97631 8.96447 10.1716L12.1464 13.3536ZM12 1L12 13L13 13L13 1L12 1Z" fill="#393d3c" />
                        <path d="M4 13C4 13.2761 4.22386 13.5 4.5 13.5C4.77614 13.5 5 13.2761 5 13L4 13ZM4.85355 0.646446C4.65829 0.451184 4.34171 0.451184 4.14645 0.646446L0.964466 3.82843C0.769203 4.02369 0.769203 4.34027 0.964466 4.53553C1.15973 4.7308 1.47631 4.7308 1.67157 4.53553L4.5 1.70711L7.32843 4.53553C7.52369 4.7308 7.84027 4.7308 8.03553 4.53553C8.2308 4.34027 8.2308 4.02369 8.03553 3.82843L4.85355 0.646446ZM5 13L5 1L4 1L4 13L5 13Z" fill="#393d3c" />
                    </svg>
                    Sort by
                </span>
            </div>
            <select
                className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
                value={value}
                onChange={onChange}
            >
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}

// export function SelectPerPage({ value, onChange, className, options }) {
//     const selectedOption = options.find(option => option.value === value);

//     return (
//         <div className="ns-sort-container">
//             <div className="ns-sort-text-container">
//                 <span className="ns-sort-text ns-second-size">
//                     {selectedOption.label} 
//                 </span>
//             </div>
//             <select
//                 className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
//                 value={value}
//                 onChange={onChange}
//             >
//                 {options.map(option => (
//                     <option key={option.value} value={option.value}>
//                         {option.label}
//                     </option>
//                 ))}
//             </select>
//         </div>
//     );
// }


// import { useState } from "preact/hooks";

// export default function Select({ value, onChange, className, options }) {
//     const [isOpen, setIsOpen] = useState(false);
//     const selectedOption = options.find(option => option.value === value);

//     return (
//         <div class="ns-sort-container">
//             <div
//                 class="ns-sort-text-container"
//                 onClick={() => setIsOpen(!isOpen)}
//             >
//                 <span class="ns-sort-text">
//                     <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M13 1C13 0.723858 12.7761 0.5 12.5 0.5C12.2239 0.5 12 0.723858 12 1L13 1ZM12.1464 13.3536C12.3417 13.5488 12.6583 13.5488 12.8536 13.3536L16.0355 10.1716C16.2308 9.97631 16.2308 9.65973 16.0355 9.46447C15.8403 9.2692 15.5237 9.2692 15.3284 9.46447L12.5 12.2929L9.67157 9.46447C9.47631 9.2692 9.15973 9.2692 8.96447 9.46447C8.7692 9.65973 8.7692 9.97631 8.96447 10.1716L12.1464 13.3536ZM12 1L12 13L13 13L13 1L12 1Z" fill="#393d3c" />
//                         <path d="M4 13C4 13.2761 4.22386 13.5 4.5 13.5C4.77614 13.5 5 13.2761 5 13L4 13ZM4.85355 0.646446C4.65829 0.451184 4.34171 0.451184 4.14645 0.646446L0.964466 3.82843C0.769203 4.02369 0.769203 4.34027 0.964466 4.53553C1.15973 4.7308 1.47631 4.7308 1.67157 4.53553L4.5 1.70711L7.32843 4.53553C7.52369 4.7308 7.84027 4.7308 8.03553 4.53553C8.2308 4.34027 8.2308 4.02369 8.03553 3.82843L4.85355 0.646446ZM5 13L5 1L4 1L4 13L5 13Z" fill="#393d3c" />
//                     </svg>
//                     Sort by
//                 </span>
//             </div>
//             {isOpen && (
//                 <div class={`ns-sort-menu ${isOpen ? "ns-show" : ""}`}>
//                     <div class="ns-sort-body">
//                         {options.map(option => (
//                             <div
//                                 key={option.value}
//                                 class="ns-sort-item"
//                                 onClick={() => {
//                                     onChange(option.value);
//                                     setIsOpen(false);
//                                 }}
//                             >
//                                 {option.label}
//                             </div>
//                         ))}
//                     </div>

//                 </div>
//             )}
//         </div>
//     );
// }
